module.exports = __webpack_public_path__ + "img/cropped-tyrel-johnson-qzOAhs1cYn4-unsplash-compressed-lazy.f05f281a.webp";